<template>
    <div>
        <x-modal class="signature" width="600" v-if="visible" @close="visible = false" :footer="false">
            <div slot="title" :class="`truncate`">
                {{ customerSignature ? `Adopt your Signature` : `Confirm your name and signature` }}
            </div>
            <div class="container col-12 mx-0" style="position:relative;">
                <div
                    class="row pt-0 amb-modal-body"
                    id="bounding-north"
                    style="-ms-overflow-y: auto; overflow-y: auto; max-height:700px;">
                    <div class="col-12" v-if="customerSignature">
                        <img :src="customerSignature.temporary_url" class="img-fluid mt-2"/>
                        <button
                            class="btn btn-blue w-100 px-2 my-2"
                            @click="useSignature"
                        >Adopt Your Saved Signature
                        </button>
                    </div>

                    <user-signature-pad
                        :user="user"
                        :verification-signature="verificationSignature"
                        v-else
                        :title="false"
                        :contract-signature="contractSignature"
                        :save-signature-url="saveSignatureUrl"
                        :submit-url="submitUrl"
                        :get-existing-signature="getExistingSignature"
                        :save-reusable-signature="saveReusableSignature"
                    ></user-signature-pad>
                </div>
            </div>
        </x-modal>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    props: {
        open: {
            required: true,
            type: Boolean
        },
        submitUrl: {
            required: true,
            type: String
        },
        saveSignatureUrl: {
            required: true,
            type: String
        },
        contractSignature: {
            required: true,
            type: Object
        },
        user: {
            required: false,
            type: Object
        },
        verificationSignature: {
            required: false,
            type: Boolean
        },
        getExistingSignature: {
            required: false
        },
        saveReusableSignature: {
            required: false
        }
    },
    data() {
        return {
            visible: false,
            overwriteSignature: false
        };
    },
    computed: {
        ...mapGetters({
            customerSignature: "signature/getCustomerSignature"
        })
    },
    methods: {
        useSignature() {
            this.$bus.$emit("add-signature", true);
            if (this.verificationSignature) this.$bus.$emit("verified", true);

            this.visible = false;
        }
    },
    mounted() {
        this.$bus.$on("close-modal", value => {
            this.visible = false;
        });
    },
    beforeDestroy() {
        this.$bus.$off("close-modal");
    },
    watch: {
        open(newVal, oldVal) {
            this.overwriteSignature = false;
            this.visible = newVal;
        },
        visible(newVal, oldVal) {
            this.$emit("update:open", newVal);
        }
    }
};
</script>
<style lang="scss">
.signature {
    @media (max-width: 650px) {
        .modal-wrapper {
            .draggable-modal {
                max-width: 100vw !important;

                .modal {
                    border-radius: 0rem;

                    .modal-body {
                        max-height: 100vh !important;
                        height: calc(100vh - 3.4rem) !important;
                        overflow-y: scroll;

                        &::-webkit-scrollbar {
                            display: none;
                        }

                        -ms-overflow-style: none;
                        scrollbar-width: none;

                        p {
                            font-size: 12px !important;
                        }

                        #bounding-north {
                            max-height: 100vh !important;

                            &::-webkit-scrollbar {
                                display: none;
                            }

                            -ms-overflow-style: none;
                            scrollbar-width: none;
                        }
                    }
                }
            }
        }
    }
}
</style>
